import type { StaticFormResult } from 'models/forms/StaticFormResult';
import type { NextWorkflowError } from 'models/NextWorkflowError';
import type { QuoteAck } from 'models/quote/QuoteAck';
import type { QuoteWarning } from 'models/QuoteWarning';
import type { DataById } from 'state/formData/formData.model';
import { FormStatus } from 'state/forms/models';
import type { NextTradeAuthorizationResult } from 'state/quotes/trades/trades.model';

export type OrdersBasketQuoteStatusType =
  | 'Accepted'
  | 'Failed'
  | 'Timeout'
  | 'Cancelled'
  | 'TranslationFailed'
  | 'Expired'
  | 'Running'
  | 'Quoted'
  | 'Rejected'
  | 'Updated';

export type OrdersBasketTradeStatusType = 'FULLY_EXECUTED' | 'FAILED' | 'EXPIRED' | 'REJECTED' | 'CANCELLED';

export interface OrdersBasketQuoteResponse {
  negotiationId: string;
  quoteId: string;
  quoteExternalId: string;
  pricingTime: number;
  solveResult: number;
  createdAt: string;
  version: number;
  status: OrdersBasketQuoteStatusType;
  rejections?: NextWorkflowError[];
  warnings?: QuoteWarning[];
}

export interface OrdersBasketTradeResponse {
  quoteId: string;
  tradeId: string;
  status: OrdersBasketTradeStatusType;
  rejections?: NextWorkflowError[];
}

export interface OrdersBasketFormMetadata {
  negotiationId: string;
  status: FormStatus;
  productType: string;
  productSubType: string;
  wrapper?: string;
  quoteAcknowledgement?: QuoteAck;
  quoteResponse?: OrdersBasketQuoteResponse;
  tradeAuthorization?: NextTradeAuthorizationResult;
  tradeResponse?: OrdersBasketTradeResponse;
}

export type OrdersBasketForm = OrdersBasketFormMetadata & {
  isSelected: boolean;
  version: number;
  result?: StaticFormResult;
  dirtyParameters?: DataById;
  updatingParameters?: DataById;
};

export type OrdersBasketFormsState = Readonly<Record<string, OrdersBasketForm>>;

export const initialOrdersBasketFormsState: OrdersBasketFormsState = {};

export interface OrdersBasketTabContent {
  tabId: string;
  workspace: 'ordersBasket';
  negotiationIds: readonly string[];
  wrapperType?: string;
  productSubtype?: string;
  productType?: string;
}
